var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEyeOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.645,
    height: 20.762,
    viewBox: "0 0 28.645 20.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_eye_off",
    transform: "translate(-1078 94.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-eye-5",
    d: "M14.34,7.387c5.67,0,9.623,3.595,11.343,5.533-1.672,2.192-5.625,6.4-11.343,6.4-5.275,0-9.465-4.22-11.312-6.453C4.81,10.9,8.777,7.387,14.34,7.387ZM14.34,5C5.306,5,0,12.819,0,12.819s5.771,8.891,14.34,8.891c9.23,0,14.3-8.891,14.3-8.891S23.523,5,14.34,5Zm-.018,3.581A4.774,4.774,0,1,0,19.1,13.355,4.775,4.775,0,0,0,14.322,8.581Z",
    transform: "translate(1078 -97.869)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_12",
    "data-name": "\\u6955\\u5186\\u5F62 12",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1092.322 -87.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_62",
    "data-name": "\\u30D1\\u30B9 62",
    d: "M1098.453-95l-18.641,18.641",
    transform: "translate(3.559 1.165)",
    fill: "none",
    stroke: "#ccc",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOff);
export default __webpack_public_path__ + "static/media/icon_eye_off.b475235641c812c5f87a55adcc3bf50d.svg";
export { ForwardRef as ReactComponent };